import { X } from 'lucide-react';
import React from 'react';

const WaitlistModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-[200] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between">
          <h2 className="text-xl font-semibold">Join SkillHub Waitlist</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="w-full h-[80vh]">
          <iframe 
            src="https://forms.fillout.com/t/3fuozC2EjZus" 
            width="100%" 
            height="100%"
            title="Waitlist Form"
            className="border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default WaitlistModal;